/**
 * Shared card styles — single source of truth for cyberpunk card appearance.
 *
 * The actual background color is controlled by the CSS variable --bg-card
 * in global.css (enforced via !important on .MuiPaper-root). These sx props
 * provide border, overflow, and accent line styling.
 *
 * To change card color globally: edit --bg-card in global.css
 * To change border-radius globally: edit border-radius in global.css .MuiPaper-root
 */
import { SxProps, Theme } from '@mui/material';

export const cyberpunkCardSx: SxProps<Theme> = {
  // Background intentionally omitted — controlled by global.css --bg-card
  // Instrument panel (2026-11-03): the same border, glow and inset accent line as InstrumentCard.
  border: '1px solid rgba(0,224,255,0.25)',
  borderRadius: 1.5,
  boxShadow: '0 0 18px rgba(0,224,255,0.06)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0, left: 16, right: 16,
    height: '2px',
    background: '#00E0FF',
    boxShadow: '0 0 12px #00E0FF, 0 0 4px #00E0FF',
  },
};

/**
 * Card without the top accent line — for secondary/list cards
 * where the gradient bar would create visual noise.
 */
export const cyberpunkCardCleanSx: SxProps<Theme> = {
  border: '1px solid rgba(0,224,255,0.22)',
  borderRadius: 1.5,
  boxShadow: '0 0 18px rgba(0,224,255,0.05)',
  position: 'relative',
  overflow: 'hidden',
};
